import { useEffect, useState } from 'react';
import { getBlogPost, getBlogList } from '../utils/api';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { useLanguage } from '../utils/LanguageContext';
import translations from './Blog.lang.json';

const Blog = () => {
  const [blogList, setBlogList] = useState([]);
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showList, setShowList] = useState(true);
  const { lang } = useLanguage(translations);
  const { currentLanguage } = useLanguage();

  useEffect(() => {
    const fetchList = async () => {
      try {
        const list = await getBlogList();
        setBlogList(list);
      } catch (error) {
        console.error('Failed to fetch blog list:', error);
      }
    };

    fetchList();
  }, []);

  const handlePostClick = async (id) => {
    setLoading(true);
    try {
      const data = await getBlogPost(id);
      setPost(data);
      setShowList(false);
    } catch (error) {
      console.error('Error fetching blog post:', error);
    } finally {
      setLoading(false);
    }
  };

  if (showList) {
    return (
      <div style={{ marginLeft: '50px' }}>
        <h2>{lang('blogTitle')}</h2>
        <ul>
          {blogList.map((item) => (
            <li key={item.id} style={{ cursor: 'pointer', color: 'blue' }} onClick={() => handlePostClick(item.id)}>
              {item.title}
            </li>
          ))}
        </ul>
      </div>
    );
  }

  if (loading) return <p>Loading blog post...</p>;
  if (!post) return <p>Blog post not found.</p>;

  const localizedContent = post.fields.languageTranslation?.[currentLanguage] || post.fields.languageTranslation?.en;

  return (
    <div className="blog-container" style={{ marginLeft: '50px' }}>
      <button onClick={() => setShowList(true)} style={{ marginBottom: '20px' }}>
        {lang('blogBackButton')}
      </button>

      <h2>{localizedContent.title}</h2>
      <p>{localizedContent.shortDescription}</p>

      {post.fields.featuredImage?.fields?.file?.url && (
        <img
          src={`https:${post.fields.featuredImage.fields.file.url}`}
          alt={post.fields.featuredImage.fields.title}
          style={{ width: '100%', maxWidth: '800px', marginBottom: '20px' }}
        />
      )}

      <div>{documentToReactComponents(localizedContent.content)}</div>
    </div>
  );
};

export default Blog;
